export const ONBOARDING = {
    'enterToken': '/enter-token',
    'step1': '/onboarding/step-one',
    'step2': '/onboarding/step-two',
    'step3': '/onboarding/step-three',
    'step4': '/onboarding/step-four',
    'step5': '/onboarding/step-five',
}